// extracted by mini-css-extract-plugin
export default {"boxFrame":"Pg_1_25_boxFrame__OWRbU","iframeWrap":"Pg_1_25_iframeWrap__tjq-c","iframe":"Pg_1_25_iframe__28aOF"};